<template>
  <!-- <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6562 5.6875C15.9832 5.6875 15.4375 5.14185 15.4375 4.46875C15.4375 3.79565 15.9832 3.25 16.6562 3.25H21.1265C22.0231 3.25 22.75 3.97687 22.75 4.8735V9.34375C22.75 10.0168 22.2043 10.5625 21.5312 10.5625C20.8582 10.5625 20.3125 10.0168 20.3125 9.34375V7.41107L15.9423 11.7812C15.4664 12.2572 14.6947 12.2572 14.2188 11.7812C13.7428 11.3053 13.7428 10.5336 14.2188 10.0577L18.5889 5.6875H16.6562ZM9.34375 20.3125H7.41107L11.7812 15.9423C12.2572 15.4664 12.2572 14.6947 11.7812 14.2188C11.3053 13.7428 10.5336 13.7428 10.0577 14.2188L5.6875 18.5889V16.6562C5.6875 15.9832 5.14185 15.4375 4.46875 15.4375C3.79565 15.4375 3.25 15.9832 3.25 16.6562V21.125C3.25 22.0225 3.97754 22.75 4.875 22.75H9.34375C10.0168 22.75 10.5625 22.2043 10.5625 21.5312C10.5625 20.8582 10.0168 20.3125 9.34375 20.3125Z"
      :fill="color"
    />
  </svg> -->

  <div>
    <svg t="1690261669565" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42623" xmlns:xlink="http://www.w3.org/1999/xlink" 
    :width="size"
    :height="size">
      <path d="M911.786667 493.312c-40.789333 208.896-254.933333 355.626667-345.088 409.045333a107.434667 107.434667 0 0 1-109.397334 0c-90.197333-53.418667-304.341333-200.106667-345.088-409.045333-17.024-87.338667 6.144-179.925333 61.994667-247.765333C225.322667 183.466667 296.362667 149.333333 374.314667 149.333333c48.981333 0 96.298667 12.416 137.685333 36.010667a277.461333 277.461333 0 0 1 137.728-36.010667c77.909333 0 148.949333 34.133333 200.106667 96.213334 55.765333 67.84 78.933333 160.426667 61.909333 247.765333z" fill="#FF3D3F" p-id="42624"></path><path d="M849.792 245.546667a297.984 297.984 0 0 1 61.013333 128.256L411.221333 873.429333c-48.213333-32.128-109.482667-78.549333-164.522666-137.386666L790.912 192c21.632 14.421333 41.386667 32.384 58.88 53.589333z" fill="#FF5052" p-id="42625"></path><path d="M649.728 149.333333c51.285333 0 99.584 14.805333 141.226667 42.624L246.741333 736.128c-48.725333-52.053333-92.544-113.749333-118.058666-183.722667l372.821333-372.736c3.541333 1.834667 6.997333 3.712 10.453333 5.674667a277.461333 277.461333 0 0 1 137.728-36.010667z" fill="#FF6365" p-id="42626"></path><path d="M374.272 149.333333c44.970667 0 88.448 10.410667 127.274667 30.336l-372.778667 372.778667a391.253333 391.253333 0 0 1-16.554667-59.136c-17.024-87.338667 6.144-179.925333 61.994667-247.765333C225.322667 183.466667 296.362667 149.333333 374.314667 149.333333z" fill="#FF8A8B" p-id="42627"></path>
    </svg>
  </div>

</template>

<script>
export default {
  name: "i-thumbsUp",
  props: {
    size: {
      type: String | Number,
      default: "30"
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>

<style scoped lang="less">
svg {
  transition: all 0.5s;
  path {
    transition: all 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/play_control/thumbsUp.vue